var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Banner',{attrs:{"id":"banner"}}),_c('BoxesArea'),_c('Services',{attrs:{"id":"services"}}),_c('ServicesArea'),_c('Works',{attrs:{"id":"works"}}),_c('Contact',{attrs:{"id":"contact"}}),_c('Partner')],1)}
var staticRenderFns = []

export { render, staticRenderFns }